import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=fb39eaa8&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=ts&"
export * from "./ModalView.vue?vue&type=script&lang=ts&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=fb39eaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb39eaa8",
  null
  
)

export default component.exports